// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSolutionOutlinedSvg from "@fishx/icons-svg/es/asn/PSolutionOutlined";
import FishxIcon from '../components/FishxIcon';

var PSolutionOutlined = function PSolutionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSolutionOutlinedSvg
  }));
};

PSolutionOutlined.displayName = 'PSolutionOutlined';
export default React.forwardRef(PSolutionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSolutionOutlined.js
// module id = 3641
// module chunks = 0